import { render, staticRenderFns } from "./TaskDealPopup.vue?vue&type=template&id=6bab3a24&scoped=true&"
import script from "./TaskDealPopup.vue?vue&type=script&lang=js&"
export * from "./TaskDealPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bab3a24",
  null
  
)

export default component.exports